import template from './cohortsShow.jade';
import 'angular-filter';
import print from 'print-js';
import {normalizeTimeframe, getDateRanges} from '../../common/datetime/date-ranges';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import Format from '../../filters/format';

const FILTER_URL_PARAMS = {
  countryCode: 'countryCode',
  device_os: 'deviceOs',
  device_type: 'deviceType',
  creative_type: 'creativeType',
  campaign: 'campaignId',
  segment: 'segmentId',
  creative: 'creativeId'
};

const URL_DATE_FORMAT = 'YYYY-MM-DD';

export class CohortsShowController {
  /* @ngInject */
  constructor($scope, $stateParams, $location, currentGame, currentUser, $localStorage, $filter, CampaignsResource, SegmentsResource, GamesResource, ggTable, CohortsResource, hideThatProduct) {
    this.CohortsResource = CohortsResource;
    this.ggTable = ggTable;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.currentGame = currentGame;
    this.truncate = $filter('truncate');
    this.apiDate = $filter('apiDate');
    this.format = $filter('format');
    this.$localStorage = $localStorage;
    this.CampaignsResource = CampaignsResource;
    this.SegmentsResource = SegmentsResource;
    this.GamesResource = GamesResource;
    this.hideThatProduct = hideThatProduct;
    this.selectedCohortType = 'cohort_date';
    this.selectedReportType = 'uu_report';
    this.selectedCohortTypeTitle = 'Cohort Date';
    this.isResourceBeingLoaded = false;
    this.selectedMetric = 'roi';
    this.selectedMetricTitle = 'ROI';
    this.tableSummary = {};
    this.metricFormat = 'percentage';
    this.searchParams = this.readSearchParamsFromUrl();
    this.isFilterWidgetOpen = false;
    this.cohortsTable = new ggTable({count: 30});
    this.tableHighestValue = 0;
    this.currentGame.subscribe((game) => {
      this.game = game;
    });
    this.cohortTypes = [];
    this.metrics = [
      { name: 'Retention', value: 'retention'},
      { name: 'ROI - All', value: 'roi_all'},
      { name: 'ROI - In App', value: 'roi'},
      { name: 'ROI - Ad Revenue', value: 'roi_ad_revenue'},
      { name: 'DAU', value: 'dau'},
      { name: 'Paying', value: 'payers_rate'},
      { name: 'Revenue - All', value: 'revenue_all'},
      { name: 'Revenue - In App', value: 'revenue'},
      { name: 'Revenue - Ad Revenue', value: 'ad_revenue'},
      { name: 'Withdrawal', value: 'withdraw'}
    ];

    this.filterFieldConfigs = {
      countryCode:{},
      device_os:{field_label:"User - OS",field_type:"string",possible_values:["iOS","Android","Windows","Mac","Linux","Other"]},
      device_type:{field_label:"User - Device",possible_values:["Desktop","Tablet","Smartphone","Other"]},
      creative_type:{field_label:"User - Creative Type",possible_values:["Banner","Video","Audio","Mraid_Playable","Mraid_Banner","Playable","Native_Banner","Native_Video", "Dynamic_Ad"]},
      campaign:{field_label:"User - Campaign",possible_values:[]},
      segment:{field_label:"User - Segment",possible_values:[]},
      creative:{field_label:"User - Creative",possible_values:[]}
    };

    this.reportTypes = [
      { name: 'Cohort (UU) Report', value: 'uu_report'},
      { name: 'Raw (non-UU) Report', value: 'raw_report'},
    ];

    this.COHORT_TYPES_FOR_NOT_ENGAGEMENT = [
      { name: 'Registration Date', value: 'cohort_date'},
      { name: 'Countries', value: 'country_code'},
      { name: 'Device OS', value: 'device_os'},
      { name: 'Device Type', value: 'device_type'},
      { name: 'Creative', value: 'creative_id'},
      { name: 'Variation', value: 'variation_id'},
      { name: 'Campaign', value: 'campaign_id'},
      { name: 'Segment', value: 'segment_id'},
      { name: 'Day of Week', value: 'day_of_week'},
      { name: 'Week of Year', value: 'week_of_year'},
      { name: 'Month of Year', value: 'month_of_year'},
      { name: 'Acquisition Source', value: 'acquisition_source'},
      { name: 'Channel', value: 'channel'},
      { name: 'Bundle', value: 'bundle'},
      { name: 'Creative Type', value: 'creative_type'}
    ];

    this.COHORT_TYPES_FOR_ENGAGEMENT = [
      { name: 'Registration Date', value: 'cohort_date'},
      { name: 'Countries', value: 'country_code'},
      { name: 'Device OS', value: 'device_os'},
      { name: 'Device Type', value: 'device_type'},
      { name: 'Creative', value: 'creative_id'},
      { name: 'Variation', value: 'variation_id'},
      { name: 'Campaign', value: 'campaign_id'},
      { name: 'Segment', value: 'segment_id'},
      { name: 'Day of Week', value: 'day_of_week'},
      { name: 'Week of Year', value: 'week_of_year'},
      { name: 'Month of Year', value: 'month_of_year'},
      { name: 'Channel', value: 'channel'},
      { name: 'Bundle', value: 'bundle'},
      { name: 'Creative Type', value: 'creative_type'}
    ];

    this.restoreSelectedValuesFromUrl();

    currentUser.subscribe((user) => {
      if(user) {
        this.timeframe = normalizeTimeframe(this.readTimeframeFromUrl() || this.$localStorage.timeframe);

        this.CampaignsResource.getList({game_id: $stateParams.gameId})
          .then(campaigns => {
            this.campaigns = campaigns;
            this.campaignsIdsToNames = campaigns.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {});
            this.filterFieldConfigs.campaign.possible_values = this.getCampaignsArrayForFilterWidget();
            this.filterFieldConfigs.campaign.campaigns = this.campaigns;
          });

        this.filterFieldConfigs.campaign.possible_values = this.getCampaignsArrayForFilterWidget();

        this.SegmentsResource.getList({game_id: $stateParams.gameId})
          .then((segments) => {
            this.segments = segments;
            this.segmentsIdsToNames = segments.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {});
            this.filterFieldConfigs.segment.possible_values = this.getSegmentsArrayForFilterWidget();
            this.filterFieldConfigs.segment.segments = this.segments;
        });
        this.filterFieldConfigs.segment.possible_values = this.getSegmentsArrayForFilterWidget();

        this.GamesResource.one($stateParams.gameId).one('creatives').get()
            .then(creatives => {
              this.creatives = creatives;
              this.creativesIdsToNames = creatives.reduce((acc, { id, external_name }) => ({ ...acc, [id]: external_name }), {});
              this.filterFieldConfigs.creative.possible_values = this.getCreativesArrayForFilterWidget();
              this.filterFieldConfigs.creative.creatives = this.creatives;
            })
        this.filterFieldConfigs.creative.possible_values = this.getCreativesArrayForFilterWidget();

        this.GamesResource.one($stateParams.gameId).getList('allVariations')
            .then((gameVariations) => {
              this.gameVariationsIdsToNames = gameVariations.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {});
            });

        //// TODO remove $watch after ng-change="vm.updateQuery()" is integrated into searchbox component
        let vm = this;
        $scope.$watch('vm.searchParams', function (newValue, oldVal) {
          if (newValue !== oldVal) {
            vm.updateCohortQuery();
          }
        }, true);

        this.showCampaignTypeSelect = !user.hasRole(['BUYER_ONLY']);

        if (this.hideThatProduct.hideAcquisitionProduct(user)) {
          this.campaignTypes = [
            { name: 'Engagement', value: 'Engagement'},
            { name: 'Organic', value: 'Organic'},
          ];
        } else {
          this.campaignTypes = [
            { name: 'Acquisition', value: 'Acquisition'},
            { name: 'Acquisition/Organic', value: 'AcquisitionAndOrganic'},
            { name: 'Engagement', value: 'Engagement'},
            { name: 'Organic', value: 'Organic'},
          ];
        }

        this.setCampaignType({value: this.getInitialCampaignType(user)});
      }
    });

  }

  readSearchParamsFromUrl() {
    let searchParams = {};

    _.forEach(FILTER_URL_PARAMS, (urlParam, searchParamKey) => {
      if (this.$stateParams[urlParam]) {
        searchParams[searchParamKey] = '' + this.$stateParams[urlParam];
      }
    });

    return searchParams;
  }

  readTimeframeFromUrl() {
    const {dateRange, startDate, endDate} = this.$stateParams;

    if (dateRange && getDateRanges()[dateRange]) {
      return {
        rangeName: dateRange,
        comparisonStartDate: null,
        comparisonEndDate: null,
        granularity: 'days'
      };
    }

    if (startDate && endDate) {
      return {
        startDate: moment(startDate, URL_DATE_FORMAT).toDate(),
        endDate: moment(endDate, URL_DATE_FORMAT).toDate(),
        comparisonStartDate: null,
        comparisonEndDate: null,
        granularity: 'days'
      };
    }

    return null;
  }

  restoreSelectedValuesFromUrl() {
    const {reportType, groupBy, metric} = this.$stateParams;

    if (_.some(this.reportTypes, {value: reportType})) {
      this.selectedReportType = reportType;
    }

    if (_.some(this.metrics, {value: metric})) {
      this.applyMetric(metric);
    }

    const cohortType = _.find(this.COHORT_TYPES_FOR_NOT_ENGAGEMENT.concat(this.COHORT_TYPES_FOR_ENGAGEMENT), {value: groupBy});

    if (cohortType) {
      this.selectedCohortType = cohortType.value;

      if (cohortType.value !== 'cohort_date') {
        this.selectedCohortTypeTitle = cohortType.name;
      }
    }
  }

  getUrlParams() {
    const timeframe = this.timeframe || {};
    let urlParams = {
      reportType: this.selectedReportType,
      groupBy: this.selectedCohortType,
      metric: this.selectedMetric,
      campaignType: this.selectedCampaignType,
      dateRange: timeframe.rangeName || null,
      startDate: timeframe.rangeName ? null : this.toUrlDate(timeframe.startDate),
      endDate: timeframe.rangeName ? null : this.toUrlDate(timeframe.endDate)
    };

    _.forEach(FILTER_URL_PARAMS, (urlParam, searchParamKey) => {
      urlParams[urlParam] = this.searchParams[searchParamKey] || null;
    });

    return urlParams;
  }

  toUrlDate(date) {
    return date ? moment(date).format(URL_DATE_FORMAT) : null;
  }

  syncUrlParams() {
    this.$location.search(this.getUrlParams()).replace();
  }

  updateCohortQuery() {
    this.loadingData = true;
    this.$localStorage.timeframe = this.timeframe;

    if (!this.$stateParams.gameId) {
      return;
    }

    this.syncUrlParams();

    let query = {
      game_id: this.$stateParams.gameId,

      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),

      breakdown_dimension: this.selectedCohortType,
      metric: this.selectedMetric,
      campaign_type: this.getCampaignTypeParamValue(this.selectedCampaignType),

      country_code: this.searchParams.countryCode,
      device_type: this.searchParams.device_type,
      creative_type: this.searchParams.creative_type,
      device_os: this.searchParams.device_os,
      creative_id: this.searchParams.creative,
      campaign_id: this.searchParams.campaign,
      segment_id: this.searchParams.segment
    };

    this.isResourceBeingLoaded = true;
    this.CohortsResource.one().get(query)
      .then(result => {
        this.tableSummary = this.removeDaysFromSummaryIfNeeded(result.data.summary);
        this.tableSummary = this.formatCohortsSummaryData(this.tableSummary);

        let cohortsData = result.data.rows;
        cohortsData = this.setEmptyCellsAndHighestValue(cohortsData, moment.utc());
        cohortsData = this.removeDaysIfNeeded(cohortsData);

        cohortsData = this.setCellsBackgroundAplha(cohortsData);
        cohortsData = this.formatCohortsData(cohortsData);

        this.cohortsTable.loadData(cohortsData);
        this.loadingData = false;
        this.isResourceBeingLoaded = false;
      });

  }

  showEngagementFirst(user) {
    return user.hasRole(['APP_DEVELOPER','ADMIN','GG_ACCOUNT_MANAGER', 'GD_ACCOUNT_MANAGER', 'AGENCY', 'OPERATION_MANAGER']);
  }

  getInitialCampaignType(user) {
    if (this.$stateParams.campaignType) {
      return this.normalizeCampaignTypeParam(this.$stateParams.campaignType);
    }

    return this.showEngagementFirst(user) ? 'Engagement' : 'Acquisition';
  }

  normalizeCampaignTypeParam(campaignType) {
    if (_.includes(['AcquisitionCPM', 'BrandingCPM'], campaignType)) {
      return 'Acquisition';
    }

    if (_.includes(['EngagementCPC', 'EngagementCPA', 'EngagementCPI'], campaignType)) {
      return 'Engagement';
    }

    return campaignType;
  }

  getCampaignTypeParamValue(selectedCampaignType) {
    switch(selectedCampaignType) {
      case 'Engagement':
            return 'Engagement,EngagementCPC,EngagementCPA,EngagementCPI';
      case 'Acquisition':
        return 'Acquisition,AcquisitionCPM,BrandingCPM';
      case 'Organic':
        return 'Organic';
      case 'AcquisitionAndOrganic':
        return 'Organic,Acquisition,AcquisitionCPM,BrandingCPM';
    }
  }

  setCellsBackgroundAplha(cohortsData) {
    _.forEach(cohortsData, (tableRowData) => {
      _.forEach(['d1', 'd3', 'd7', 'd14', 'd30', 'd31'], (column) => {
        tableRowData[column + 'BgAlpha'] = this.tableHighestValue && tableRowData[column] ? tableRowData[column] / this.tableHighestValue : 0;
        tableRowData[column + 'BgAlpha'] = +tableRowData[column + 'BgAlpha'].toFixed(2);
      });
    });

    return cohortsData;
  }

  getDaysOfOffsetForCurrentBucket(bucketName) {
    switch (bucketName) {
      case 'd1':
        return 0;
        break;
      case 'd3':
        return 2;
        break;
      case 'd7':
        return 4;
        break;
      case 'd14':
        return 8;
        break;
      case 'd30':
        return 15;
        break;
      case 'd31':
        return 31;
        break;
      default:
        return 1000
    }
  }

  isAppLevelUUReportWithNonUniqueCampaign() {
    return this.selectedReportType === 'uu_report'
              && !this.searchParams.campaign
              && !_.every(this.campaigns, campaign => campaign.conversion_attribution === 'unique');
  }

  isAppLevelRawReportWithNonUniqueCampaign() {
    return this.selectedReportType === 'raw_report'
              && !this.searchParams.campaign
              && !_.every(this.campaigns, campaign => campaign.conversion_attribution === 'non_unique');
  }

  removeDaysIfNeeded(cohortsData) {
    if (this.selectedReportType === 'raw_report') {
      const resetDay1 = !['roi', 'roi_all', 'roi_ad_revenue', 'revenue', 'ad_revenue', 'revenue_all', 'withdraw'].includes(this.selectedMetric);
      const daysToReset = resetDay1 ? ['d1', 'd3', 'd7', 'd14', 'd30', 'd31'] : ['d3', 'd7', 'd14', 'd30', 'd31'];
      _.forEach(cohortsData, (tableRowData) => {
        _.forEach(daysToReset, (column) => {
          tableRowData[column] = '';
        });
      });
    }

    return cohortsData;
  }

  removeDaysFromSummaryIfNeeded(tableSummary) {
    if (this.selectedReportType === 'raw_report') {
      const resetDay1 = !['roi', 'roi_all', 'roi_ad_revenue', 'revenue', 'ad_revenue', 'revenue_all', 'withdraw'].includes(this.selectedMetric);
      const totalDaysToReset = resetDay1 ? ['d1_total', 'd3_total', 'd7_total', 'd14_total', 'd30_total', 'd31_total'] : ['d3_total', 'd7_total', 'd14_total', 'd30_total', 'd31_total'];
      _.forEach(totalDaysToReset, (column) => {
        tableSummary[column] = '';
      })
    }
    return tableSummary;
  }

  setEmptyCellsAndHighestValue(cohortsData, now) {
    let offsetDays, referenceDate;
    this.tableHighestValue = 0;
    _.forEach(cohortsData, (tableRowData) => {
        referenceDate = this.selectedCohortType === 'cohort_date' ? tableRowData.key : this.timeframe.startDate;
        _.forEach(['d1', 'd3', 'd7', 'd14', 'd30', 'd31'], (column) => {
          this.tableHighestValue = tableRowData[column] > this.tableHighestValue ? tableRowData[column] : this.tableHighestValue;
          offsetDays = this.getDaysOfOffsetForCurrentBucket(column);
          if(moment.utc(referenceDate).add(offsetDays,'days').isAfter(now)) { tableRowData[column] = ''; }
        });
    });
    return cohortsData;
  }

  formatCohortsData(cohortsData) {
    _.forEach(cohortsData, (tableRowData) => {
      _.forEach(['d1', 'd3', 'd7', 'd14', 'd30', 'd31'], (column) => {
        if(this.selectedMetric === 'payers_rate') {
          return this.format(tableRowData[column], 'number')
        }
        return tableRowData[column] = typeof tableRowData[column] === 'number' ? this.format(tableRowData[column], this.metricFormat) : tableRowData[column];
      });
    });
    return cohortsData;
  }

  formatCohortsSummaryData(cohortsSummaryData) {
    _.chain(cohortsSummaryData).pick(['d1_total', 'd3_total', 'd7_total', 'd14_total', 'd30_total', 'd31_total'])
      .forEach((value, column) => {
        if(this.selectedMetric === 'payers_rate') {
          cohortsSummaryData[column] = this.format(value, 'number');
        } else {
          cohortsSummaryData[column] = typeof value === 'number' ? this.format(value, this.metricFormat) : value;
        }
    }).value();
    return cohortsSummaryData;
  }

  filterCampaignBySelectedType(campaign) {
    return campaign.type.toLowerCase().indexOf(this.selectedCampaignType.toLowerCase()) >= 0
        || campaign.type === 'BrandingCPM' && this.selectedCampaignType === 'Acquisition';
  }

  filterCampaignByReportType(campaign) {
    return this.selectedReportType === 'uu_report' && campaign.conversion_attribution === 'unique'
      || this.selectedReportType === 'raw_report' && campaign.conversion_attribution === 'non_unique'
  }

  filterCampaigns() {
    return _.chain(this.campaigns)
      .filter(campaign => this.filterCampaignBySelectedType(campaign))
      .orderBy(
      [
        c => String(c.status).toLowerCase() !== 'active',
        c => Number(c.id) || 0
      ],
        ['asc', 'asc']
      )
      .value();
  }

  getSegmentLabel(segment_id, shouldTruncate) {
    if (!this.loadingData && this.segmentsIdsToNames && this.selectedCohortTypeTitle === 'Segment') {
      if (shouldTruncate) {
        return `${this.truncate(this.segmentsIdsToNames[segment_id] || 'unknown', 40,
            '...')} (${segment_id})`;
      } else {
        return `${this.segmentsIdsToNames[segment_id] || 'unknown'} (${segment_id})`;
      }
    }
    return '';
  }

  getCampaignLabel(campaign_id, shouldTruncate) {
    if (!this.loadingData && this.campaignsIdsToNames && this.selectedCohortTypeTitle === 'Campaign') {
      if (shouldTruncate) {
        return `${this.truncate(this.campaignsIdsToNames[campaign_id] || 'unknown', 40,
            '...')} (${campaign_id})`;
      } else {
        return `${this.campaignsIdsToNames[campaign_id] || 'unknown'} (${campaign_id})`;
      }

    }
    return '';
  }

  getCreativeLabel(creative_id, shouldTruncate) {
    if (!this.loadingData && this.creativesIdsToNames && this.selectedCohortTypeTitle === 'Creative') {
      if (shouldTruncate) {
        return `${this.truncate(this.creativesIdsToNames[creative_id] || 'unknown', 40,
            '...')} (${creative_id})`;
      } else {
        return `${this.creativesIdsToNames[creative_id] || 'unknown'} (${creative_id})`;
      }

    }
    return '';
  }

  getVariationLabel(variation_id, shouldTruncate) {
    if (!this.loadingData && this.gameVariationsIdsToNames && this.selectedCohortTypeTitle === 'Variation') {
      if (shouldTruncate) {
        return `${this.truncate(this.gameVariationsIdsToNames[variation_id] || 'unknown', 40,
            '...')} (${variation_id})`;
      } else {
        return `${this.gameVariationsIdsToNames[variation_id] || 'unknown'} (${variation_id})`;
      }

    }
    return '';
  }

  applyMetric(value) {
    const metric = _.find(this.metrics, {value}) || _.find(this.metrics, {value: 'roi'});

    this.selectedMetric = metric.value;
    this.selectedMetricTitle = metric.name;
    this.metricFormat = this.getMetricFormat(metric.value);
  }

  getMetricFormat(metric) {
    if (_.includes(['retention', 'roi', 'roi_all', 'roi_ad_revenue'], metric)) {
      return 'percentage';
    }

    if (_.includes(['revenue', 'ad_revenue', 'revenue_all', 'withdraw'], metric)) {
      return 'USD';
    }

    return 'number';
  }

  handleCohortTypeChange(selected) {
    this.selectedCohortTypeTitle = selected.name;
    this.updateCohortQuery();
  }

  handleReportTypeChange(selected) {
    this.selectedReportType = selected.value;
    delete this.searchParams.campaign;
    this.filterFieldConfigs.campaign.possible_values = this.getCampaignsArrayForFilterWidget();
    this.updateCohortQuery();
  }

  handleMetricChange(selected) {
    this.applyMetric(selected.value);
    this.updateCohortQuery();
  }

  handleCampaignTypeChange(selected) {
    delete this.searchParams.campaign;
    this.setCampaignType(selected);
  }

  setCampaignType(selected) {
    this.selectedCampaignType = selected.value;

    if (selected.value === 'Engagement') {
      this.cohortTypes = this.COHORT_TYPES_FOR_ENGAGEMENT;
    } else {
      this.cohortTypes = this.COHORT_TYPES_FOR_NOT_ENGAGEMENT;
    }

    _.forEach(this.cohortTypes, (cohortType) => {
      if(cohortType.value === 'cohort_date') {
        cohortType.name = selected.value === 'Acquisition' ? 'Registration Date' : 'Conversion Date';
      }
    });
    this.filterFieldConfigs.campaign.possible_values = this.getCampaignsArrayForFilterWidget();
    this.updateCohortQuery();
  }

  getCampaignsArrayForFilterWidget() {
    return _.map(this.filterCampaigns(), (campaign) => {
      return {
        valueToShow: this.truncate(campaign.id + ' - ' + campaign.name, 50,
            '...'),
        value: '' + campaign.id
      };
    });
  }

  getSegmentsArrayForFilterWidget() {
    return _.map(this.segments, (segment) => {
      return {
        valueToShow: this.truncate(segment.id + ' - ' + segment.name, 30,
            '...'),
        value: '' + segment.id
      };
    });
  }

  getCreativesArrayForFilterWidget() {
    return _.map(this.creatives, (creative) => {
      return {
        valueToShow: this.truncate(creative.id + ' - ' + creative.name, 30,
            '...'),
        value: '' + creative.id
      };
    });
  }

  getExportDataWithNameSummary(){
    const {count, players_count, cost, d1_total, d3_total, d7_total, d14_total, d30_total, d31_total} = this.tableSummary;
    return { key: count, name: null, size: players_count, cost: cost, d1: d1_total, d3: d3_total, d7: d7_total, d14: d14_total, d30: d30_total, d31: d31_total }
  }

  getExportDataWithName() {
    let vm = this;
    const data = _.map(this.cohortsTable.loadedData, (row) => {
      let name = '';
      if (!vm.loadingData) {
        if (vm.selectedCohortTypeTitle === 'Creative' && vm.creativesIdsToNames) {
          name = vm.creativesIdsToNames[row.key] || 'unknown';
        } else if (vm.selectedCohortTypeTitle === 'Segment' && vm.segmentsIdsToNames) {
          name = vm.segmentsIdsToNames[row.key] || 'unknown';
        } else if (vm.selectedCohortTypeTitle === 'Campaign' && vm.campaignsIdsToNames) {
          name = vm.campaignsIdsToNames[row.key] || 'unknown';
        } else if (vm.selectedCohortTypeTitle === 'Variation' && vm.gameVariationsIdsToNames) {
          name = vm.gameVariationsIdsToNames[row.key] || 'unknown';
        }
      }
      return { key:row.key, name, size:row.size, cost:row.cost, d1:row.d1, d3:row.d3, d7:row.d7, d14:row.d14, d30:row.d30, d31:row.d31 };
    });
    return [this.getExportDataWithNameSummary(), ...data];
  }

  getExportDataWithoutNameSummary(){
    const {count, players_count, cost, d1_total, d3_total, d7_total, d14_total, d30_total, d31_total} = this.tableSummary;
    return { key: count, size: players_count, cost: cost, d1: d1_total, d3: d3_total, d7: d7_total, d14: d14_total, d30: d30_total, d31: d31_total }
  }

  getExportDataWithoutName() {
    const data = _.map(this.cohortsTable.loadedData, (row) => {
      return { key:row.key, size:row.size, cost:row.cost, d1:row.d1, d3:row.d3, d7:row.d7, d14:row.d14, d30:row.d30, d31:row.d31 };
    });
    return [this.getExportDataWithoutNameSummary(), ...data];
  }

  getExportData() {
    if (this.selectedCohortTypeTitle === 'Creative' || this.selectedCohortTypeTitle === 'Segment' || this.selectedCohortTypeTitle === 'Campaign' || this.selectedCohortTypeTitle === 'Variation') {
      return this.getExportDataWithName();
    }
    return this.getExportDataWithoutName();
  }

  exportHeader() {
    if (this.selectedCohortTypeTitle === 'Creative' || this.selectedCohortTypeTitle === 'Segment' || this.selectedCohortTypeTitle === 'Campaign' || this.selectedCohortTypeTitle === 'Variation') {
      return ['Cohort', 'Name', 'Cohort Size', 'Cost', 'Day 1', 'Day 3', 'Day 7', 'Day 14', 'Day 30', 'Day 31'];
    }
    return ['Cohort', 'Cohort Size', 'Cost', 'Day 1', 'Day 3', 'Day 7', 'Day 14', 'Day 30', 'Day 31'];
  }

  getStyle(type) {
    return {
      'background-color': 'rgba(90, 174, 239, '+ type +')',
      '-webkit-print-color-adjust': `exact`
    }
  }

  printTable() {
    print({
      printable: 'cohortTable',
      type: 'html',
      targetStyles: ['*'],
      maxWidth: 'auto',
      style: '@page { size: Letter landscape; }'
    })
  }

}

export function CohortsShowComponent() {
  return {
    template,
    controller: CohortsShowController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  }
}

export default angular.module('app.components.cohorts.show', [
  'angular.filter',
  'ngCsv',
  Format.name,
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('cohortsShow', CohortsShowComponent);



/** WEBPACK FOOTER **
 ** ./src/components/cohorts/cohortsShow.js
 **/